import React from 'react';
import { TEMPLATE } from '../../config/index.js';
import ContestCards from './ContestCards.js';

export default function FeaturedList({ coops, contests, taxonomyArticle }) {
  return (
    <>
      <section className="section section--lg u--background-color-white u--padding-top-0 u--padding-bottom-0">
        <div className="container container--xl">
          {taxonomyArticle.length > 0 && (
            <>
              <div
                key={taxonomyArticle}
                data-card-size="large"
                className="grid card__grid"
              >
                {taxonomyArticle &&
                  taxonomyArticle.map((article) => (
                    <div
                      key={article.id}
                      className="grid__col-lg-6 grid__col-xs-12"
                    >
                      <article className="card">
                        <a href={article.url}>
                          <img
                            src={
                              article.image['card-large']
                                ? article.image['card-large']
                                : article.image
                            }
                            className="card__media"
                            alt={article.title}
                          />
                          <section className="card__body card__body--large">
                            <p className="card__category">{article.kicker}</p>
                            <h4
                              className="card__title"
                              dangerouslySetInnerHTML={{
                                __html: article.title
                              }}
                            />
                            <p
                              className="card__description"
                              dangerouslySetInnerHTML={{
                                __html: article.subheader
                              }}
                            />
                            {article.byline && (
                              <p className="card__byline">
                                {(article.byline_credit || 'By') + ' ' + article.byline}
                              </p>
                            )}
                          </section>
                        </a>
                        <hr className="card__hr" />
                      </article>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </section>
      {TEMPLATE === 'templates/page-category-sub.php' && (
        <ContestCards coops={coops} contests={contests} />
      )}
      <section className="section section--lg u--padding-top-0 u--background-color-white">
        <div id="gpt-ad-slot-square-1" className="ad__container"></div>
      </section>
    </>
  );
}
